/* Lence PDP — ported interactivity + Shopify cart wiring */
(function () {
  function init() {
    if (window.__lpdpInit) return;
    window.__lpdpInit = true;
    /* Reveal on scroll */
    var revEls = document.querySelectorAll('.lpdp [data-reveal]');
    if ('IntersectionObserver' in window && revEls.length) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.08 });
      revEls.forEach(function (el) { io.observe(el); });
      var revealInView = function () {
        var vh = window.innerHeight || 800;
        revEls.forEach(function (el) {
          if (!el.classList.contains('in')) {
            var r = el.getBoundingClientRect();
            if (r.top < vh * 0.92 && r.bottom > 0) { el.classList.add('in'); io.unobserve(el); }
          }
        });
      };
      requestAnimationFrame(revealInView);
      window.addEventListener('scroll', revealInView, { passive: true });
      setTimeout(function () { revEls.forEach(function (el) { el.classList.add('in'); }); }, 2500);
    } else {
      revEls.forEach(function (el) { el.classList.add('in'); });
    }

    /* Gallery thumbs + swipe */
    var main = document.getElementById('mainImg');
    if (main) {
      var thumbBtns = Array.prototype.slice.call(document.querySelectorAll('#thumbs button'));
      var gSrcs = thumbBtns.map(function (b) { return b.dataset.src; });
      var gIdx = 0;
      main.draggable = false;
      var showImg = function (i) {
        if (!gSrcs.length) return;
        gIdx = (i + gSrcs.length) % gSrcs.length;
        main.src = gSrcs[gIdx];
        thumbBtns.forEach(function (x, xi) { x.classList.toggle('active', xi === gIdx); });
      };
      thumbBtns.forEach(function (b, i) {
        b.addEventListener('click', function () { showImg(i); });
      });
      var gframe = main.closest('.gframe') || main.parentNode;
      if (gframe && gSrcs.length > 1) {
        gframe.style.touchAction = 'pan-y';
        var sx = 0, sy = 0, tracking = false, TH = 40;
        gframe.addEventListener('touchstart', function (e) {
          if (!e.touches || !e.touches.length) return;
          sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
        }, { passive: true });
        gframe.addEventListener('touchend', function (e) {
          if (!tracking) return; tracking = false;
          var t = e.changedTouches && e.changedTouches[0]; if (!t) return;
          var dx = t.clientX - sx, dy = t.clientY - sy;
          if (Math.abs(dx) > TH && Math.abs(dx) > Math.abs(dy)) showImg(gIdx + (dx < 0 ? 1 : -1));
        }, { passive: true });
        var pdown = false, px = 0;
        gframe.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' || e.pointerType === 'pen') { pdown = true; px = e.clientX; }
        });
        gframe.addEventListener('pointerup', function (e) {
          if (!pdown) return; pdown = false;
          var dx = e.clientX - px;
          if (Math.abs(dx) > TH) showImg(gIdx + (dx < 0 ? 1 : -1));
        });
      }
    }

    /* Before / after slider */
    var range = document.getElementById('baRange'), clip = document.getElementById('baClip'), handle = document.getElementById('baHandle');
    if (range && clip && handle) {
      var setBA = function (v) { clip.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)'; handle.style.left = v + '%'; };
      range.addEventListener('input', function (e) { setBA(e.target.value); });
      setBA(50);
    }

    /* Sticky bar visibility */
    var sticky = document.getElementById('sticky'), buy = document.getElementById('buy');
    if (sticky && buy && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (es) {
        es.forEach(function (e) { sticky.classList.toggle('show', !e.isIntersecting); });
      }, { threshold: 0 });
      so.observe(buy);
    }

    /* Bundle & save + scratch-to-reveal gifts */
    var bundlesWrap = document.getElementById('bundles');
    var bundles = bundlesWrap ? Array.prototype.slice.call(bundlesWrap.querySelectorAll('.bundle')) : [];
    var grid = document.getElementById('giftGrid');
    var unlocked = 2;
    var sel = bundlesWrap ? bundlesWrap.querySelector('.bundle.sel') : null;
    if (sel) unlocked = +sel.dataset.gifts || 1;

    if (grid) {
      var gifts = Array.prototype.slice.call(grid.querySelectorAll('.gift'));
      var countEl = document.getElementById('giftCount');
      var noteEl = document.getElementById('giftNote');
      var resetBtn = document.getElementById('giftReset');
      var COLORS = ['#2F4A3C', '#B85A3C', '#B0894F'];

      var shade = function (hex, pct) {
        var n = parseInt(hex.slice(1), 16), r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255, m = 1 + pct / 100;
        r = Math.max(0, Math.min(255, r * m | 0)); g = Math.max(0, Math.min(255, g * m | 0)); b = Math.max(0, Math.min(255, b * m | 0));
        return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
      };
      var draw = function (c, i) {
        var r = c.getBoundingClientRect(); if (!r.width) return;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        c.width = r.width * dpr; c.height = r.height * dpr;
        var ctx = c.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.globalCompositeOperation = 'source-over';
        var col = COLORS[i % 3]; var grd = ctx.createLinearGradient(0, 0, r.width, r.height);
        grd.addColorStop(0, col); grd.addColorStop(1, shade(col, -24)); ctx.fillStyle = grd; ctx.fillRect(0, 0, r.width, r.height);
        ctx.fillStyle = 'rgba(255,255,255,.45)';
        for (var k = 0; k < 24; k++) { ctx.beginPath(); ctx.arc(Math.random() * r.width, Math.random() * r.height, Math.random() * 1.5, 0, 7); ctx.fill(); }
        ctx.fillStyle = 'rgba(255,255,255,.94)'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        var fs = Math.max(9, r.width * 0.115); ctx.font = '700 ' + fs + 'px Inter,sans-serif';
        ctx.save(); ctx.translate(r.width / 2, r.height / 2);
        ctx.fillText('S C R A T C H', 0, -fs * 0.55); ctx.fillText('M E', 0, fs * 0.75); ctx.restore();
        c.dataset.armed = '1'; c.dataset.done = '0'; c.dataset.touched = '0'; c.style.opacity = '1';
      };
      var check = function (c, g) {
        if (c.dataset.done === '1') return;
        var d; try { d = c.getContext('2d').getImageData(0, 0, c.width, c.height).data; } catch (_) { return; }
        var cl = 0, t = 0; for (var p = 3; p < d.length; p += 160) { t++; if (d[p] < 40) cl++; }
        if (t && cl / t > 0.52 && c.dataset.touched === '1') {
          c.dataset.done = '1'; c.style.transition = 'opacity .3s'; c.style.opacity = '0';
          setTimeout(function () { g.classList.add('claimed'); update(); }, 300);
        }
      };
      var bind = function (c, g) {
        if (c.dataset.bound === '1') return; c.dataset.bound = '1';
        var ctx = c.getContext('2d'); var down = false;
        var pt = function (e) {
          var r = c.getBoundingClientRect();
          var cx = e.touches ? e.touches[0].clientX : e.clientX, cy = e.touches ? e.touches[0].clientY : e.clientY;
          return { x: cx - r.left, y: cy - r.top };
        };
        var erase = function (e) {
          if (!down || c.dataset.armed !== '1') return;
          var p = pt(e); var r = c.getBoundingClientRect();
          ctx.globalCompositeOperation = 'destination-out'; ctx.beginPath(); ctx.arc(p.x, p.y, r.width * 0.17, 0, 7); ctx.fill();
          if (e.cancelable) e.preventDefault(); check(c, g);
        };
        c.addEventListener('pointerdown', function (e) { down = true; c.dataset.touched = '1'; try { c.setPointerCapture(e.pointerId); } catch (_) {} erase(e); });
        c.addEventListener('pointermove', erase);
        window.addEventListener('pointerup', function () { down = false; });
      };
      var apply = function () {
        gifts.forEach(function (g, i) {
          var c = g.querySelector('canvas');
          if (i < unlocked) {
            g.classList.remove('locked');
            if (!g.classList.contains('claimed')) { draw(c, i); bind(c, g); }
          } else {
            g.classList.remove('claimed'); g.classList.add('locked'); c.dataset.armed = '0';
          }
        });
        update();
      };
      var update = function () {
        var claimed = gifts.filter(function (g, i) { return i < unlocked && g.classList.contains('claimed'); }).length;
        if (countEl) countEl.firstChild.nodeValue = claimed + '/' + unlocked;
        if (noteEl) noteEl.textContent = unlocked >= 3 ? 'Every gift is yours to claim.' : ('Upgrade to unlock ' + (3 - unlocked) + ' more');
      };
      bundles.forEach(function (b) {
        b.addEventListener('click', function () {
          bundles.forEach(function (x) { x.classList.remove('sel'); }); b.classList.add('sel');
          unlocked = +b.dataset.gifts || 1;
          var stickyPr = document.querySelector('.lpdp .sticky .pr');
          if (stickyPr) stickyPr.innerHTML = b.dataset.price + '<s>' + b.dataset.was + '</s>';
          apply();
        });
      });
      if (resetBtn) resetBtn.addEventListener('click', function () {
        gifts.forEach(function (g, i) { if (i < unlocked) { g.classList.remove('claimed'); var c = g.querySelector('canvas'); draw(c, i); bind(c, g); } });
        update();
      });
      var rt; window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () { gifts.forEach(function (g, i) { if (i < unlocked && !g.classList.contains('claimed')) draw(g.querySelector('canvas'), i); }); }, 200);
      });
      setTimeout(apply, 60);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () {
        gifts.forEach(function (g, i) { if (i < unlocked && !g.classList.contains('claimed')) draw(g.querySelector('canvas'), i); });
      });
    } else if (bundles.length) {
      bundles.forEach(function (b) {
        b.addEventListener('click', function () {
          bundles.forEach(function (x) { x.classList.remove('sel'); }); b.classList.add('sel');
        });
      });
    }

    /* Add to cart — quantity presets from the selected bundle */
    var addToCart = function (btn) {
      if (!bundlesWrap) return;
      var chosen = bundlesWrap.querySelector('.bundle.sel') || bundles[0];
      var variantId = +((chosen && chosen.dataset.variant) || bundlesWrap.dataset.variant);
      var qty = chosen ? (+chosen.dataset.qty || 1) : 1;
      if (!variantId) return;
      var items = [{ id: variantId, quantity: qty }];
      var giftAttr = chosen ? (chosen.dataset.giftVariants || '') : '';
      giftAttr.split(',').forEach(function (gv) {
        var gid = parseInt((gv || '').trim(), 10);
        if (gid) items.push({ id: gid, quantity: 1 });
      });
      var label = btn.querySelector('.cta-label');
      var prev = label ? label.textContent : null;
      if (label) label.textContent = 'Adding…';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.href = '/cart';
      }).catch(function () {
        btn.disabled = false;
        if (label && prev) label.textContent = prev;
        window.location.href = '/cart/add?id=' + variantId + '&quantity=' + qty;
      });
    };
    document.querySelectorAll('.lpdp [data-lpdp-atc]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); addToCart(btn); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
